import { cn } from "@/lib/utils";
import Image from "next/image";
import Link from "next/link";

function Header2({ data }: { data: any }) {
  const { background_color, logo } = data.data || {};

  return (
    <header
      className={cn(
        "sticky top-0 z-40 bg-white flex items-center justify-between rounded-spacing-10 size-full",
        "px-2 py-4",
        "sm:px-spacing-36 sm:py-spacing-8 ",
        "xl:px-spacing-46 xl:py-spacing-6",
        "2xl:px-spacing-56 2xl:py-spacing-8"
      )}
      style={{
        backgroundColor: background_color,
      }}
    >
      <div
        className={cn(
          "flex items-center justify-start shrink-0",
          "sm:gap-spacing-24 ",
          "md:gap-spacing-26 ",
          "lg:gap-spacing-30 ",
          "2xl:gap-spacing-36 "
        )}
      >
        {logo && (
          <Link
            href="/"
            className={cn(
              "bg-left bg-no-repeat bg-[length:100%_96%] rounded-spacing-14 shrink-0",
              "h-[40px] w-[96px]",
              "sm:h-[52px] sm:w-[152px]",
              "md:h-[60px] md:w-[174px]",
              "lg:h-[68px] xl:w-[200px]",
              "2xl:h-[84px] 2xl:w-[216px]"
            )}
          >
            <Image
              alt="Logo"
              className="block max-w-none size-full object-contain"
              src={logo}
              width={216}
              height={84}
            />
          </Link>
        )}
      </div>
    </header>
  );
}

export default Header2;
